import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import safeLocalStorage from '../../../../../../../shared/utils/safeLocalStorage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavigationButtons from '../../components/NavigationButtons';
import WaitingTimePeriodSelector from './components/WaitingTimePeriodSelector';

import { FadeIn, RadioInput } from 'hosman-material';
import { D_CircleExclamation } from 'hosman-material';

import { updateEstimationData } from '../../../../../../reducers/_Pages/Public/rentalFunnelSlice';

const Reason = () => {
  const { estimationData, estimationData: { competition }, errors } = useSelector((state) => state.rentalFunnel);
  const dispatch = useDispatch();
  // We need to reinitialize hasEffectRun to make sure it can rerun for a new estimation
  safeLocalStorage.removeItem('hasEffectRun');

  return (
    <div data-testid='Reason'>
      <FadeIn>
        <div className='flex flex-col gap-10'>
          <p className='h2 text-ih-indigo'>Quand souhaitez-vous mettre ce bien en location ?</p>

          <WaitingTimePeriodSelector />

          <RadioInput
            name='competition'
            label='Avez-vous un mandat de gestion en cours avec une autre agence ?'
            options={[
              { name: 'Oui', value: true },
              { name: 'Non', value: false }
            ]}
            value={competition}
            onChange={(val) => dispatch(updateEstimationData({ ...estimationData, competition: val }))}
            errors={errors}
          />
        </div>

        <div className='flex flex-col gap-6'>
          {errors.waitingTimePeriod &&
            <div className='flex justify-start items-center gap-2 mt-2'>
              <FontAwesomeIcon icon={D_CircleExclamation} size='lg' className='text-ih-red' />

              <p className='text-ih-red-60 text-xs'>{errors.waitingTimePeriod}</p>
            </div>
          }

          <NavigationButtons classes='hidden md:block my-5' />
        </div>
      </FadeIn>
    </div>
  )
}

export default Reason;
